import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import {
  AuthenticatedStorefrontAPIPOSTRequest,
  AuthenticatedStorefrontAPIRequest,
  StorefrontApiResponse,
} from 'components/discovery/shared/ecommerce-api-token/api/ecommerce-api-token-api.js'
import { fetchAuthenticated } from 'components/discovery/shared/ecommerce-api-token/api/authenticated-request.js'
import type { OrderTemplates } from 'components/discovery/product/add-to-order-templates/typing/order-templates-types.js'

export const ORDER_TEMPLATES_API = Symbol('ORDER_TEMPLATES_API')

export class GetOrderTemplatesRequest extends AuthenticatedStorefrontAPIRequest { }

export class CreateOrderTemplateRequest extends AuthenticatedStorefrontAPIPOSTRequest {
  constructor(endpointUrl: string, tokenEndpoint: string, name: string, groupId: number | string, type: string) {
    super(tokenEndpoint, endpointUrl)
    this.body = JSON.stringify({ name, group_id: groupId, type })
  }
}

export interface OrderTemplatesAPI {
  getOrderTemplates(request: GetOrderTemplatesRequest): StorefrontApiResponse<OrderTemplates>
  createOrderTemplate(request: CreateOrderTemplateRequest): StorefrontApiResponse<OrderTemplates>
}

@registerDependency(FAKE, ORDER_TEMPLATES_API)
export class FakeOrderTemplatesAPI implements OrderTemplatesAPI {
  orderTemplatesRequests: GetOrderTemplatesRequest[] = []
  orderTemplatesData: OrderTemplates | null = null

  createOrderTemplateRequests: CreateOrderTemplateRequest[] = []
  createOrderTemplateData: OrderTemplates | null = null

  throws: Error | null = null

  async getOrderTemplates(request: GetOrderTemplatesRequest): Promise<OrderTemplates> {
    this.orderTemplatesRequests.push(request)
    if (this.throws) throw this.throws
    return this.orderTemplatesData as OrderTemplates
  }

  async createOrderTemplate(request: CreateOrderTemplateRequest): Promise<OrderTemplates> {
    this.createOrderTemplateRequests.push(request)
    if (this.throws) throw this.throws
    return this.createOrderTemplateData as OrderTemplates
  }
}

@registerDependency(REAL, ORDER_TEMPLATES_API)
export class RealOrderTemplatesAPI implements OrderTemplatesAPI {
  private authenticatedFetch<T = unknown>(request: AuthenticatedStorefrontAPIRequest) {
    const body = request instanceof AuthenticatedStorefrontAPIPOSTRequest ? request.body : undefined
    return fetchAuthenticated<T>(request, body)
  }

  async getOrderTemplates(request: GetOrderTemplatesRequest) {
    return this.authenticatedFetch<OrderTemplates>(request)
  }

  async createOrderTemplate(request: CreateOrderTemplateRequest) {
    return this.authenticatedFetch<OrderTemplates>(request)
  }
}
